import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';

import useService from '../../utils/useService';
import useUserService from '../../../../userManagement/utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../helper';
import { getFormDefaults } from './helper';
import { IPermissionSet } from '../../../../../../models/settingsV2.model';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const { requestCreatePermissionsSet } = useService();
	const { getPermissionsOptions } = useUserService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.SELECT_PERMISSIONS].setRenderProps({ getOptions: getPermissionsOptions });

	const data = getFormDefaults();

	const history = useHistory();

	const createPermissionsSet = async (formData: IPermissionSet) => {
		setShowLoader(true);

		try {
			const response = await requestCreatePermissionsSet(app.appName, formData);
			if (!response?.data?.success) {
				throw new Error(response?.data?.message || 'Failed to create permissions set');
			}
		} catch (err: any) {
			const errorMessage: string = err.response?.data?.error || err?.message;
			showAlert(errorMessage ?? 'Error while creating this permission Set', { type: 'error' });
			setShowLoader(false);

			history.goBack();
			return;
		}
		showAlert('Permission Set created successfully', { type: 'success' });
		setShowLoader(false);

		history.goBack();
	};

	const handleFormSubmit = (formData: IPermissionSet) => {
		createPermissionsSet(formData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
